<div id="page-container">
  <div id="audit-title" class="flex flex-row gap-10 align-items-start">
    <img src="assets/audit-icon.svg" class="icon-inline">
    <div class="flex flex-column">
      <h1 class="light-blue text-lg no-margin">HISTORIQUE DES CONTRÔLES <span class="text-md">(AUTOMATIQUE ET
          MANUEL)</span></h1>
      <p class="grey text-sm no-margin">L’historique des contrôles automatiques ou manuels consigne toutes les
        vérifications
        effectuées afin d’en assurer
        la traçabilité.</p>
    </div>
  </div>

  <div id="audit-filters" class="flex flex-row gap-10 align-items-center">
    <img src="assets/filters-icon.svg" class="icon-inline" style="margin-left: 41px;">
    <p class="dark-blue text-sm">Type :</p>
    <select id="audit-mode" name="audit-mode" [(ngModel)]="filterValue" (ngModelChange)="onFilterChange()">
      <option value="tous">Tous</option>
      <option value="auto">Automatique</option>
      <option value="manuel">Manuel</option>
    </select>
    <button class="flex align-items-center flex-row" id="download-report" (click)="downloadReport()"><img
        src="assets/download-icon.svg" class="icon-inline">Télécharger le rapport</button>
  </div>

  <div>
    <p-table [value]="filteredAudits" [tableStyle]="{'width': '100%'}" styleClass="p-datatable-striped"
      [paginator]="true" [rows]="5">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="checkupType" style="width:10%">
            Type <p-sortIcon field="checkupType" />
          </th>
          <th pSortableColumn="time" style="width:25%">
            Date / Heure <p-sortIcon field="time" />
          </th>
          <th pSortableColumn="apiVersion" style="width:12%">
            Version <p-sortIcon field="apiVersion" />
          </th>
          <th pSortableColumn="electionHash" style="width:15%">
            Empreinte <p-sortIcon field="electionHash" />
          </th>
          <th pSortableColumn="triggeredBy" style="width:20%">
            Déclenché par <p-sortIcon field="triggeredBy" />
          </th>
          <th pSortableColumn="integrity" style="width:18%">
            Résultat <p-sortIcon field="integrity" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-audit>
        <tr>
          <td class="text-center bold">{{ auditType(audit.checkupType) }}</td>
          <td>{{ formatDate(audit.time) }}</td>
          <td class="bold">{{ audit.apiVersion }}</td>
          <td>{{ audit.electionHash }}</td>
          <td>{{ audit.auditOwner }}</td>
          <td class="flex align-items-center"
            [ngClass]="isAuditCompliant(audit.integrity) === 'Conforme' ? 'green' : 'red'">
            <span id="bullet" class="rounded mr-5"
              [ngClass]="isAuditCompliant(audit.integrity) === 'Conforme' ? 'bg-green' : 'bg-red'"></span>
            {{ isAuditCompliant(audit.integrity) }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- <div class="flex flex-column gap-10 content-center align-items-center">
    <p *ngIf="audits && audits.length > 0" class="dark-blue"><img src="assets/flag-icon.svg" class="icon-inline"><span class="bold light-blue">
        Dernier contrôle par : </span> <span class="bold">{{audits[0].auditOwner}}</span>, le {{formatDate(audits[0].time)}}</p>
    <button class="action-button" (click)="startAudit()">Déclencher le contrôle</button>

    <p *ngIf="auditSuccess" class="success-message flex flex-row gap-10 align-items-center"><img src="assets/success-icon.svg" class="icon-inline">Contrôle réussi.</p>
  </div> -->

</div>